import { axiosInstance2 } from "./axiosInstance";

const formApi = {
  submitLead: async (payload) => {
    return await axiosInstance2.post(
      "v1/leads/axesell-submit",
      payload
    );
  },

    getTimeSlots: async (date) => {
    return await axiosInstance2.get                                                                   (
      `v1/meeting-booking/slots?date=${date}`
    );
  },
};

export default formApi;